import './style.scoped.css';
import { useCallback } from 'react';
import Promotion from 'src/models/Promotion';
import { sendOpenNewWebview } from 'src/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useTranslation } from 'react-i18next';
import { PromotionStatus } from 'src/constants';
dayjs.extend(customParseFormat);

interface PromotionListItemProps {
  data: Promotion;
}
const PromotionListItem = (props: PromotionListItemProps) => {
  const { data } = props;
  const { t } = useTranslation();

  const _handleClick = useCallback(() => {
    sendOpenNewWebview(data);
  }, [data]);

  const _getDisplayPepriod = (): string => {
    const fromDayjs = data.fromDate ? dayjs(data.fromDate) : null;
    const toDayjs = data.toDate ? dayjs(data.toDate) : null;
    const dateFormat =
      !fromDayjs || !toDayjs || fromDayjs.year() != toDayjs.year()
        ? t('date_format3')
        : t('day_month_format');
    // console.log('Date format', fromDayjs.year(), toDayjs.year());
    return `${fromDayjs ? fromDayjs.format(dateFormat) : ''}-${
      toDayjs ? toDayjs.format(dateFormat) : ''
    }`;
  };

  const _renderStatusBadge = () => {
    if (data.promotionStatus == PromotionStatus.FINISHED) {
      return <div className="badge2 bg-onSurfaceVariant">{t('finished')}</div>;
    }
    if (data.promotionStatus == PromotionStatus.HAPPENING) {
      return <div className="badge2 bg-primary">{t('happening')}</div>;
    }
    return <div className="badge2 bg-secondary">{t('upcoming')}</div>;
  };

  return (
    <div className={'item'} key={data.id} onClick={_handleClick}>
      <div className={`data`}>
        {/* <div
          className={'itemImage'}
          key={data.id}
          style={{ backgroundImage: `url(${data.photo})` }}
        /> */}
        <img className={'itemImage'} src={data.photo} />
        <div className={'contentContainer'}>
          <div className="blockTitle name">{data.name}</div>
          <div className="flex flex-row">
            <div className={'badge2 bg-attention mr-2'}>
              {_getDisplayPepriod()}
            </div>
            {_renderStatusBadge()}
          </div>
        </div>
      </div>
    </div>
  );
};
export default PromotionListItem;
